module.exports = __webpack_public_path__ + "static/media/Monster Rocker.93168ed2.jpg";